import React, { useEffect, useState } from "react";
import { Button, Chip, DocumentsList, FormFieldSet, Modal, PageTitle, useFormHandler } from "../../../../../../../components";
import { BillRateType, PayType } from "../../../../../../../assets/data/enumData";

const PaymentViewModel = ({ open, onClose, rowData, handleChangeMain, }) => {
  console.log("rowData in view", rowData);
   const isEditable = !!rowData;
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    effectiveDate: "",
    billingType: "",
    billRate: "",
    vmsCharges: "",
    payType: "",
    purchaseOrder: "",
    payRatehr: "",
  });
 const [attachmentModal, setAttachmentModal] = useState(false);
       const [selectedDocuments,setSelectedDocuments]=useState([])
useEffect(()=>{
  if(isEditable){
 handleChange("effectiveDate", rowData?.effectiveDate);
      handleChange("payType", rowData?.payRate?.payType);
        handleChange(
        "payRatehr",`${rowData?.payRate?.payRatePerHour||""}`);
      handleChange("percent", rowData?.payRate?.percent);
      handleChange("subPercent", rowData?.payRate?.subPercent);
      handleChange("vmsCharges", rowData?.vmsCharges);
      handleChange(
        "purchaseOrder",
        `${rowData?.poNum ||""}`
      );
      handleChange("billingType", rowData?.billRate?.type);
      handleChange("billRate", `${rowData?.billRate?.rate||""}`);
  }
},[isEditable,rowData])
const combineAttachmentsPoLink = rowData?.poLink?.map((filePath) => ({
  filePath,
  name: "Purchase Order",
})) || [];
  return (
    <Modal isOpen={open} onClose={onClose} title="VIEW" width="max-w-7xl">
      <div>
        <div className="flex">
          <PageTitle title={"Bill Rate"} tag="h6"/>
        </div>
        <div className="grid grid-cols-3 mt-4 gap-x-6 gap-y-4 ">
          <FormFieldSet
            type="datepicker"
            title={"Effective Date"}
            placeholder="01/02/2025"
            value={formData.effectiveDate}
            onChange={(value) => handleChange("passportNumber", value)}
            error={errors.passportNumber}
            disabled={isEditable}
            showDropdown={false}
          />
          <FormFieldSet
            type="select"
            title={"Billing Type"}
            placeholder="Select Billing Type"
            value={formData.billingType}
            onChange={(value) => handleChange("billingType", value)}
            error={errors.billingType}
            options={BillRateType}
            disabled={isEditable}
          />
          <FormFieldSet
            type="text"
            title={"Bill Rate"}
            placeholder="Select Bill Rate"
            value={formData.billRate}
            onChange={(value) => handleChange("billRate", value)}
            error={errors.billRate}
            options={""}
            disabled={isEditable}
          />
          <FormFieldSet
            type="text"
            title={"VMS Charges"}
            placeholder="Select VMS Charges"
            value={formData.vmsCharges}
            onChange={(value) => handleChange("vmsCharges", value)}
            error={errors.vmsCharges}
            options={""}
            disabled={isEditable}
          />
        </div>
        <div className="flex mt-6">
          <PageTitle title={"Pay Rate"} tag="h6"/>
        </div>
        <div className="grid grid-cols-3 mt-4 gap-x-6 gap-y-4 ">
          <div className="flex items-center">
            <div className="flex-1">
              <FormFieldSet
                type="select"
                title={"Pay Type"}
                placeholder="Enter Pay Type"
                value={formData.payType}
                onChange={(value) =>
                  handleChange("payType", value)
                }
                error={errors.payType}
                options={PayType}
                disabled={isEditable}
              />
            </div>
            <div className="bg-primary text-white p-[7px] mt-[18px] rounded-tr-sm rounded-br-sm cursor-pointer">
              %
            </div>
          </div>
          <FormFieldSet
            type="text"
            title={"Pay Rate/HR"}
            placeholder="Select Pay Rate/HR"
            value={formData.payRatehr}
            onChange={(value) => handleChange("payRatehr", value)}
            error={errors.payRatehr}
            options={""}
            disabled={isEditable}
          />
          <FormFieldSet
            type="text"
            title={"Purchase Order Number"}
            placeholder="Select purchaseOrderNumber"
            value={formData.purchaseOrder}
            onChange={(value) => handleChange("purchaseOrderNumber", value)}
            error={errors.purchaseOrder}
            options={""}
            disabled={isEditable}
          />
          <FormFieldSet
            type="file"
            title={"Purchase Order"}
            placeholder="Choose File"
            value={formData.purchaseOrder}
            onChange={(value) => handleChange("purchaseOrder", value)}
            error={errors.purchaseOrder}
            options={""}
            disabled={isEditable}
          />
        </div>
        <div
          className=" flex rounded-md items-center cursour-pointer"
          onClick={() => {
            setAttachmentModal(!attachmentModal)
            setSelectedDocuments(combineAttachmentsPoLink)
          }}
        >
          <Chip
            label={`Purchase Order:-${combineAttachmentsPoLink.length}`}
            icon={"docs"}
            iconPosition={"before"}
          />
        </div>
        <div className="flex justify-end gap-3 mt-6 mb-6">
          <Button title={"Close"} variant="outlined" onClick={onClose} />
        </div>
        <Modal
        isOpen={attachmentModal}
        onClose={() => setAttachmentModal(false)}
        // title="Attachment View"
        // width="max-w-5xl"
        width="max-w-2xl"
        title={"Document Details"}
      >
        {/* <div className="flex flex-col justify-center items-center gap-8">
              <h6>attachement Details</h6> */}
        <DocumentsList data={selectedDocuments} />
        {/* <Button
                title={"Close"}
                onClick={() => setAttachmentModal(false)}
              /> */}
        {/* </div> */}
      </Modal>
      </div>

    </Modal>
  );
};


export default PaymentViewModel;

